import { create } from 'zustand';

interface CopilotStore {
  isOpen: boolean;
  isMaximized: boolean;
  prefillMessage: string | null;
  pageContext: string | null;
  continuation: { conversationId: string; messageId: string; tenantId: string; ownerId: string } | null;
  openContinuation: (context: NonNullable<CopilotStore['continuation']>) => void;
  clearContinuation: () => void;
  openCopilot: (message?: string) => void;
  closeCopilot: () => void;
  toggleMaximize: () => void;
  clearPrefill: () => void;
  setPageContext: (ctx: string | null) => void;
}

export const useCopilotStore = create<CopilotStore>((set) => ({
  isOpen: false,
  isMaximized: false,
  prefillMessage: null,
  pageContext: null,
  continuation: null,
  openContinuation: (continuation) => set({ isOpen: true, prefillMessage: null, continuation }),
  clearContinuation: () => set({ continuation: null }),
  openCopilot: (message?: string) => set({ isOpen: true, prefillMessage: message || null }),
  closeCopilot: () => set({ isOpen: false, prefillMessage: null, isMaximized: false }),
  toggleMaximize: () => set((s) => ({ isMaximized: !s.isMaximized })),
  clearPrefill: () => set({ prefillMessage: null }),
  setPageContext: (ctx) => set({ pageContext: ctx }),
}));
